// Archives.js
import React from 'react';
import { archives } from './ArchivesData';
import '../styles/LeChetom.css';

const Archives = () => {
    return (
        <section className="archive-recent-section">
            <div className="container">
                <div className="section-header fade-in">
                    <span className="section-tag">Nouveautés</span>
                    <h2>Quelques-unes de nos archives les plus récemment reçues</h2>
                </div>

                <div className="archive-modern-grid">
                    {archives.map(archive => (
                        <div key={archive.id} className="archive-card fade-in">
                            <div className="archive-image-wrapper">
                                <img src={archive.image} alt={archive.title} />
                                <div className="archive-card-overlay">
                                    <div className="archive-card-content">
                                        <h3>{archive.title}</h3>
                                        <p className="archive-card-date">{archive.date}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="archive-footer-action">
                    <a className="btn btn-hero" style={{ minWidth: '280px' }} href="/pages/FormulaireChetom">
                        <span>Accéder à davantage d'archives</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                            <path d="M5 12h14M12 5l7 7-7 7"/>
                        </svg>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Archives;